import { actions } from '../../utils/constants'

export const openModal = ({ component, dialogProps = {}, size = 'md', title, confirmText = "Submit", resetText = "Cancel", onCancle, onConfirm }) => {
  return { type: actions.OPEN_MODAL, component, size, title, confirmText, resetText, onCancle, onConfirm, dialogProps }
}
export const closeModal = () => {
  window.localStorage.removeItem("user_form_value");
  return { type: actions.CLOSE_MODAL }
}
